import type { EditablePoint } from '@/modules/Editor/point'

type MetaNode = { name: string; color?: string }
type DataNode = { name: string; point: EditablePoint; occluded: boolean }
type SerializedNode = { x: number; y: number; name: string; occluded: boolean; color?: string }

export const serializeNodesWithColors = (
  dataNodes: DataNode[],
  metaNodes?: MetaNode[],
): SerializedNode[] => {
  const nodeColorByName = new Map<string, string>()
  for (const metaNode of metaNodes ?? []) {
    if (metaNode.color !== undefined) {
      nodeColorByName.set(metaNode.name, metaNode.color)
    }
  }

  return dataNodes.map((node) => {
    const color = nodeColorByName.get(node.name)
    return {
      x: node.point.x,
      y: node.point.y,
      name: node.name,
      occluded: node.occluded,
      ...(color !== undefined ? { color } : {}),
    }
  })
}
